import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getStockorderList } from 'components/stockorder/StockorderAPI';
import { getListAPI as getStockorderProductList } from 'components/stockorderproduct/StockorderproductAPI';
import { setStockorderList, setStockorderproductList, setStockorderDashboardStockorderList } from 'store/slice/ManufSlice';
import StockorderDashboard from '../StockorderDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function StockorderPageImpl() {
    const dispatch = useDispatch();
    const { stockorderList} = useSelector((state)=>state.manufslice);
    
    const getStockorderListSuccess = (list) =>{dispatch(setStockorderList(list));}
    useEffect(() => {
        getStockorderList(()=>{}, getStockorderListSuccess);
        getStockorderProductList(()=>{}, (data) => {
            dispatch(setStockorderproductList(data));
        })
    },[]);

    useEffect(()=>{
        dispatch(setStockorderDashboardStockorderList( stockorderList));
    },[ stockorderList])

    return (
        < StockorderDashboard />
    )

}